// MessageBubble.tsx
import { observer } from 'mobx-react-lite';

import { komplyanceAiChatMessage } from '@app/pages';
import { FeedbackRating } from '@libs/types';

import { ResponseBubble } from './ResponseBubble';
import { UserBubble } from './UserBubble';

interface MessageBubbleProps {
  message: komplyanceAiChatMessage;
  onFeedback?: (messageId: string, rating: FeedbackRating) => void;
  isFeedbackSubmitting?: boolean;
  conversationId?: string;
}

export const MessageBubble: React.FC<MessageBubbleProps> = observer(
  ({ message, onFeedback, isFeedbackSubmitting = false, conversationId }) => {
    const isUserMessage = message.type === 'user';
    const isStreaming = message.id === 'streaming';

    if (isUserMessage) {
      return <UserBubble message={message} conversationId={conversationId} />;
    }

    return (
      <ResponseBubble
        message={message}
        onFeedback={onFeedback}
        isFeedbackSubmitting={isFeedbackSubmitting}
        isStreaming={isStreaming}
      />
    );
  },
);
